import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { Listing } from "../../types";
import { markListingAsSold } from "../../api";

export default function useMarkListingAsSold() {
  const queryClient = useQueryClient();
  
    const mutation = useMutation<
      AxiosResponse<Listing>,
      { response?: { data?: { message?: string } } },
      string
    >({
      mutationFn: (uid: string) => markListingAsSold(uid),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["listings"] });
      },
    });
  
    return mutation;
}